<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role == 'CUSTOMER_CARE'"><a
        routerLink="/admin/customercareOrders/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Customers</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text ml-1" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col-md-8">
      <ul class="list-inline tab-list deskContent">
        <li class="list-inline-item"><a (click)="populateTabData('all','ALL'); resetCheckedList();tabChange();"
                                        [ngClass]="{'active': tabClicked === 'all'}">All</a></li>

        <li class="list-inline-item"><a (click)="populateTabData('active','ACTIVE');resetCheckedList();tabChange();"
                                        [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
        <li class="list-inline-item"><a
          (click)="populateTabData('inprocess','IN_ACTIVE');resetCheckedList();tabChange();"
          [ngClass]="{'active': tabClicked === 'inprocess'}">Inactive</a></li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;"
              data-value="All" required>
        <option value="ALL">All</option>
        <option value="ACTIVE">Active</option>
        <option value="IN_ACTIVE">Inactive</option>
      </select>
    </div>
    <div class="col-md-4 text-right">

      <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
              *ngIf="tabClicked !== 'all'">
        Actions
      </button>

      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"
           *ngIf="(checkedList?.length)">
        <a *ngIf="tabClicked === 'active'"
           (click)="processPayment()" class="dropdown-item file btn shift-import">Add Credits</a>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th>Company Name</th>
            <th>Contact</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Created Date</th>
            <th>Status</th>
          </tr>
          </thead>

          <tbody class="table-body-custom">
          <tr *ngFor="let ao of accountOwners;let i = index;">
            <td>
              <div class="form-checkbox" *ngIf="tabClicked === 'active'">
                <input type="checkbox" id="{{ao.id}}" [(ngModel)]="ao.isSelected" name="list_name"
                  (change)="selectShip(ao)">
                <label for="{{ao.id}}"></label>
              </div>
              <a class="ml-2" routerLink="/admin/viewAccountOwner/{{ao.id}}">{{ao.companyName}}</a>
            </td>
            <td>{{ao.ownerName}}</td>
            <td>{{ao.mobile}}</td>
            <td><span class="shift-email-width">{{ao.email}}</span></td>
            <td>{{ao.createdDate}}</td>
            <td>
              <div class="row">
                <div class="col-md-6">
                  <div class="toggle-2 d-inline">
                    <input type="checkbox" name="onoffswitch" id="customSwitch_{{ao.id}}" class="custom-control-input"
                           (click)="changeStatus(ao, i)" [checked]="ao.status==='ACTIVE'" class="checkbox"/>
                    <label for="customSwitch_{{ao.id}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <a (click)="openPasswordPopup(ao)" id="action">
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                         width="20pt" height="20pt" viewBox="0 0 981.000000 982.000000"
                         preserveAspectRatio="xMidYMid meet">

                      <g transform="translate(0.000000,982.000000) scale(0.100000,-0.100000)"
                         fill="#ee7125" stroke="none">
                        <path d="M4585 9800 c-956 -66 -1860 -399 -2615 -964 -277 -207 -642 -555
                    -852 -811 -520 -638 -865 -1363 -1022 -2155 -295 -1477 105 -3006 1084 -4150
                    115 -134 353 -374 500 -503 885 -776 2033 -1207 3220 -1207 1076 0 2101 345
                    2961 997 1642 1243 2326 3373 1720 5349 -43 139 -136 393 -149 406 -5 5 -132
                    -43 -283 -105 -229 -95 -274 -117 -273 -133 1 -10 25 -81 53 -157 331 -889
                    343 -1906 35 -2826 -300 -893 -898 -1674 -1684 -2198 -583 -389 -1215 -617
                    -1935 -700 -210 -24 -682 -23 -890 1 -215 25 -416 61 -599 107 -1212 304
                    -2233 1125 -2794 2245 -361 721 -509 1541 -426 2354 130 1270 823 2417 1889
                    3127 1175 782 2648 935 3965 411 154 -61 440 -198 440 -210 0 -5 -111 -162
                    -246 -349 -135 -187 -243 -343 -241 -346 7 -7 2098 -314 2114 -311 7 2 -139
                    400 -388 1053 -219 578 -402 1058 -406 1068 -6 14 -51 -42 -205 -255 -108
                    -150 -210 -292 -226 -314 l-30 -42 -204 102 c-238 120 -420 196 -648 272 -352
                    118 -731 198 -1110 234 -150 14 -602 20 -755 10z"/>
                        <path d="M4695 7349 c-464 -63 -792 -349 -943 -819 -67 -211 -82 -337 -82
                    -711 l0 -296 -69 -12 c-240 -43 -438 -239 -514 -508 -22 -78 -22 -81 -22
                    -1003 0 -1050 -3 -1001 82 -1173 63 -125 182 -247 295 -301 145 -70 78 -67
                    1491 -64 l1272 3 65 22 c136 47 264 147 346 270 52 79 100 211 114 313 8 59
                    10 357 7 975 -3 980 -1 935 -67 1081 -96 213 -285 362 -497 391 l-43 6 0 251
                    c0 287 -11 439 -40 580 -109 530 -425 878 -885 976 -115 25 -394 35 -510 19z
                    m417 -630 c196 -54 326 -196 378 -410 18 -76 20 -118 20 -436 l0 -353 -611 0
                    -610 0 3 383 3 382 29 83 c91 262 303 391 618 376 53 -3 129 -14 170 -25z
                    m-94 -1824 c42 -9 113 -33 157 -55 183 -89 298 -248 327 -450 26 -188 -73
                    -372 -274 -506 l-68 -46 0 -379 0 -379 -265 0 -265 0 0 378 0 378 -69 48 c-86
                    59 -192 170 -226 236 -31 61 -55 151 -55 205 0 22 7 72 15 110 40 192 182 356
                    368 427 124 48 230 57 355 33z"/>
                      </g>
                    </svg>
                  </a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="accountOwners?.length===0|| !accountOwners?.length">
            <td colspan="6" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Company Name</th>
            <th>Contact</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Created Date</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let ao of accountOwners;let i = index;">
            <td><b class=" tablesaw-cell-label">Company Name</b>
              <span class="tablesaw-cell-content"><a class="" routerLink="/admin/editAccountOwner/{{ao.id}}"
                                                     style="text-transform:capitalize;">{{ao.companyName}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Contact</b>
              <!--              <span class="tablesaw-cell-content"><a routerLink ="/admin/dashboard/" (click)="selectAccountOwner(ao)">{{ao.ownerName}}</a></span></td>-->
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">
            {{ao.ownerName}}
            </span>
            <td><b class=" tablesaw-cell-label">Phone Number</b>
              <span class="tablesaw-cell-content">{{ao.mobile}}</span></td>
            <td><b class=" tablesaw-cell-label">Email</b>
              <span class="tablesaw-cell-content">{{ao.email}}</span></td>
            <td><b class=" tablesaw-cell-label">Created Date</b>
              <span class="tablesaw-cell-content">{{ao.createdDate}}</span></td>
            <td>
              <b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (click)="changeStatus(ao, i)"
                       id="customerSwitch_{{ao.id}}" [checked]="ao.status==='ACTIVE'">
                <label class="custom-control-label" for="customerSwitch_{{ao.id}}"> </label>
              </div>
              </span></td>
            <td><b class=" tablesaw-cell-label">Details</b>
              <span class="tablesaw-cell-content">
              <a class="ml-2" id="modalActivateAccO" (click)="showWarehouse(ao.id)" data-toggle="modal"
                 href="#exampleModalPreview">
                                  <img src="assets/images/Idetails.png" width="20px" height="20px"
                                       routerLink="/admin/warehouseRequestCreate/">

              </a>
              </span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div [ngStyle]="{'display': popUp =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': popUp == 'Y'}" class="modal" id="popUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Update Password</h5>
        <button type="button" class="close" (click)="closePasswordPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col-md-6">
              <label for="userCurrent">Current Password</label>
              <input id="userCurrent" type="text" class="form-control" [(ngModel)]="currentPassword" (blur)="typeCurrentPwd()"
                     [ngModelOptions]="{standalone: true}"/>
            </div>
            <div id="currentPwdError" class="invalid-feedback d-block shift-invalid-login"
                 [hidden]="!currentPwdError">{{currentPwdError}}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <label for="user">Enter Password</label>
              <input id="user" type="text" class="form-control" [(ngModel)]="newPassword" (blur)="typeNewPwd()"
                     [ngModelOptions]="{standalone: true}"/>
            </div>
            <div id="newPwdError" class="invalid-feedback d-block shift-invalid-login"
                 [hidden]="!newPwdError">{{newPwdError}}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label for="userReEnter">Renter Password</label>
              <input id="userReEnter" type="text" class="form-control" [(ngModel)]="renterPassword" (blur)="typeConfirmPwd()"
                     [ngModelOptions]="{standalone: true}"/>
            </div>
            <div id="confirmPwdError" class="invalid-feedback d-block shift-invalid-login"
                 [hidden]="!confirmPwdError">{{confirmPwdError}}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="submitChangePassword()">Update</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
